export default function pluralize (str, count) {
  return count > 1 ? `${str}s` : str
}